import React from "react";
import { connect } from "react-redux";
import { getLogoImageUrl } from "Portal/NewPortal/FollowupForm/selectors";
import { actions, getters } from "Portal/NewPortal/FollowupForm/model";
import { isEmptyOrNil } from "utils/General";

import Avatar from "Portal/NewPortal/Shared/Avatar";
const decorate = connect(
  state => ({
    logoImageUrl: getLogoImageUrl(state),
    formData: getters.formData(state),
    eventName: getters.eventName(state),
    eventSlug: getters.eventSlug(state)
  }),
  {
    goToPortalHome: actions.goToPortalHome
  }
);

const Logo = ({
  logoImageUrl,
  header = false,
  goToPortalHome,
  formData,
  eventName,
  eventSlug
}) =>
  logoImageUrl ? (
    <div
      title="Go to PortalHome"
      style={{
        width: header ? "24px" : "80px",
        minHeight: header ? "24px" : "80px",
        cursor: "pointer",
        background: isEmptyOrNil(logoImageUrl) ? "transparent" : "white"
      }}
      onClick={() => {
        goToPortalHome(formData);
      }}
    >
      {!isEmptyOrNil(logoImageUrl) && (
        <img
          alt={logoImageUrl}
          aria-label={logoImageUrl}
          src={logoImageUrl}
          style={{
            maxWidth: "100%"
          }}
        />
      )}

      {isEmptyOrNil(logoImageUrl) && (
        <Avatar
          name={eventName}
          type={header ? "small" : "huge"}
          id={eventSlug}
          square
        />
      )}
    </div>
  ) : null;

export default decorate(Logo);
